module.exports = __webpack_public_path__ + "img/top_recommend@3x.6a9ad920.png";